import { RequestAuthorizationArgs } from './default.provider';
import LibraryBaseProvider from './library.base.provider';

class AdfsProvider extends LibraryBaseProvider {
    override requestAuthorization({ provider, authtype, key, url, context }: RequestAuthorizationArgs): Promise<unknown> {
        // standalone window mode, out of pressreader site, used by native apps
        if (context.isWindowMode) {
            window.location.href = url;
            return Promise.resolve();
        }

        return super.requestAuthorization({ provider, authtype, key, url, context });
    }
}

export default AdfsProvider;
